module.exports = __webpack_public_path__ + "static/img/new-code-icon3.a1f26a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/popup/new-code-icon3.png
// module id = /osv
// module chunks = 1